const snackConst = {};
const CURRENCY = "Lei";
const otpRegex = /^\d{6}$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const cuiRegex = /^RO\d{8}$/;
const passwordRegex =
  /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/;

const skuRegex = /^[A-Za-z0-9_-]{3,30}$/;
const partialSkuRegex = /^[A-Za-z0-9_-]*$/;

const socialLinkRegex = {
  facebook: /^(https?:\/\/)?(www\.|m\.)?(facebook|fb)\.com\/.+/i,
  tiktok: /^(https?:\/\/)?(www\.|vm\.)?tiktok\.com\/.+/i,
  instagram: /^(https?:\/\/)?(www\.)?instagram\.com\/.+/i,
};

const STRIPE_KEY = process.env.REACT_APP_STRIPE_API_KEY;

const MAX_IMAGE_SIZE = 3 * 1024 * 1024;

const ALLOWED_IMAGE__FORMATS = ["png", "jpeg", "jpg"];
const ALLOWED_VIDEO_FORMATS = ["mp4", "mov", "avi", "mkv"];

const DEFAULT_VAT_PERCENTAGE = 21;

const requestType = {
  POST: "post",
  GET: "get",
  PUT: "put",
  DELETE: "delete",
  PATCH: "patch",
};

// const PRODUCT_USAGE_TYPE = [
//   {
//     value: "normal",
//     label: {
//       en: "Normal",
//       ro: "Obișnuit",
//     },
//   },
//   {
//     value: "professional",
//     label: {
//       en: "Professional",
//       ro: "Profesionist",
//     },
//   }
// ]

const PRODUCT_USAGE_TYPE = [
  {
    value: "home",
    label: {
      en: "Normal",
      ro: "Normal",
    },
  },
  {
    value: "business",
    label: {
      en: "Professional",
      ro: "Profesionist",
    },
  },
];

const PACKAGE_USAGE_TYPE = [
  {
    value: "home",
    label: {
      en: "Home",
      ro: "Obișnuit",
    },
  },
  {
    value: "business",
    label: {
      en: "Business",
      ro: "Afaceri",
    },
  },
];

const INVENTORY_MOVEMENT_REASON = [
  {
    value: "stock_in",
    label: {
      en: "Stock In",
      ro: "Intrare în stoc",
    },
  },
  {
    value: "stock_out",
    label: {
      en: "Stock Out",
      ro: "Ieșire din stoc",
    },
  },
  {
    value: "release",
    label: {
      en: "Release",
      ro: "Eliberare",
    },
  },
  {
    value: "adjustment",
    label: {
      en: "Adjustment",
      ro: "Ajustare",
    },
  },
  {
    value: "price_adjustment",
    label: {
      en: "Price Adjustment",
      ro: "Ajustare de preț",
    },
  },
];


const ORDER_STATUS_TRANSITIONS = {
  pending: ["processing", "cancelled", "user_cancelled"],
  processing: ["shipped", "cancelled", "user_cancelled"],
  shipped: ["delivered"],
  delivered: [],
  cancelled: [],
  user_cancelled: [],
};

const endPoints = {
  // Common endpoints

  updateAllAcountStatus: "update/account-status",
  getAddressDetailByPlaceId: "address-detail/get",
  getCurrentSubscription: "subscription-history/get-current",

  // Chat
  getAllChatsByConversationId: "chat/messages",
  startConversation: "chat/start",
  getConversationByCompanyId: "chat/conversation/get-by",
  getSingleConversationWithAdmin: "chat/conversation/get-signle",
  getAllConversationOfCompanyWithWorker: "chat/company-with-worker",
  getSingleCoversationOfWorkerWithCompany:
    "chat/conversation/worker-with-company",
  getConversationWorkerWithUser: "chat/conversation/worker-with-user",
  getAppointmentChat: "company/appointment/get-chat",

  // SubscriptionHistory endpoints

  getSubscriptionHistoryByUserId: "subscription-history/get-by-user",
  createSubscriptionHistory: "subscription-history/create",

  // Admin Category endpoints

  getAllSubscriptionByRole: "admin/subscription/get-by-role",
  getSubscriptionDetailById: "admin/subscription/get-by-id",

  // Supplier Authentication endpoints

  supplierSendCode: "supplier/send-code",
  registerSupplier: "supplier/register",
  loginSupplier: "supplier/login",
  forgetPasswordSupplier: "supplier/forget-password",
  verifyPasswordSupplier: "supplier/verify-password",
  changePasswordSupplier: "supplier/change-password",
  updateSupplier: "supplier/update-profile",
  getAllSupplier: "supplier/get-all",
  getSupplierDetails: "get-details",
  supplierUpdateProfile: "supplier/update-profile",
  supplierUpdateSubscription: "supplier/update-subscription",
  getSupplierCurrentSubscription: "supplier/current-subscription",
  supplierPurchaseSubscription: "supplier/purchase-subscription",

  // Company Authentication Endpoints

  companySendCode: "company/send-code",
  registerCompany: "company/register",
  companyRegisterWorker: "company/create/worker",
  loginCompany: "company/login",
  forgetPasswordCompany: "company/forget-password",
  verifyPasswordCompany: "company/verify-password",
  changePasswordCompany: "company/change-password",
  updateCompany: "company/update-profile",
  getAllCompany: "company/get-all",
  getCompanyDetails: "get-details",
  updateCompanyProfile: "company/update-profile",
  updateCompanySubscription: "company/update-subscription",
  updateCompanyServices: "company/update-services",
  getAllCompanyServices: "company/services",
  getAllCompanySubServices: "company/sub-service",
  getCompanyCurrentSubscription: "company/current-subscription",
  companyPurchaseSubscripton: "company/purchase-subscription",
  companyCanCreateWorker: "company/can-create-worker",

  // Company Services

  getAllServicesWithSubServices: "service/subservice/get-all",

  // Company Services Endpoints

  createCompanyServices: "company/service/create",
  getCompanyServices: "company/service/get",
  getCompanyPreSelectedServices: "company/service/get-selected",
  updateCompanyOwnSerivce: "company/service/udpate",
  getAllWorkersByCompanyId: "company/workers/get-all",
  getCompanyRelatedToServices: "company/get-acc-services",
  getCompanySelectedServices: "company/get-selected-services",
  getCompanyDashboardStates: "company/dashboard-states/get",
  getCompanycommingJobs: "company/upcomming-jobs/get",
  getCompanyPopularService: "company/popular-services/get",
  getCompanyMonthlyEarning: "company/monthly-earning/get",
  getCompanyAllClients: "company/users/get-all",
  getCompanyReport: "company/report/get",
  getWorkerForFilters: "worker/get-for-filters",
  // Company role endpoints

  createCompanyRole: "company/role/create",
  getAllCompanyRole: "company/role/get-all",
  updateCompanyRole: "company/role/update",
  deleteCompanyRole: "company/role/delete",

  // Company user endpoints
  createCompanyUser: "company/user/create",
  getAllCompanyUser: "company/user/get-all",
  updateCompanyUser: "company/user/update",
  deleteCompanyUser: "company/user/delete",

  // Company Customers endpoints
  companyCustomerCreate: "user/register/company",
  companyCustomersGet: "user/get-all",
  companyCustomersStatusUpdate: "user/block-status",
  companyCustomerUpdate: "user/update",

  // Worker Endpoints

  workerSendCode: "worker/send-code",
  registerWorker: "worker/register",
  loginWorker: "worker/login",
  updateWorkerProfile: "worker/update-profile",
  changeWorkerPassword: "worker/change-password",
  getWorkerReviews: "worker/get-review",
  getWorkerDashboardStates: "worker/dashboard-states/get",
  getWorkerUpcommingJobs: "worker/upcomming-jobs/get",
  getWorkerReport: "worker/report/get",
  getWorkerDetail: "worker/detail",
  updateWorkderDetail: "worker/update",
  workerPurchaseSubscripton: "worker/purchase-subscription",
  updateWorkerAvailability: "worker/availability/set",
  getWorkerAvailability: "worker/availability/get",

  // Appointment endpoints

  getAppointmentsByWorkerId: "company/appointment/get-by-workerId",
  getAppointmentsByCompanyId: "company/appointment/get-by-companyId",
  getAppointmentDetail: "company/appointment/detail",
  updateAppointmentStatus: "company/appointment/update-status",
  updateAppointmentWorkerStatus: "company/appointment/update-worker-status",

  // notification endpoints

  getUserNotification: "admin/notification/get-by-role",
  markReadNotification: "notification/mark-all-read",

  // Admin Setting endpoints
  getSetting: "admin/setting/get-latest",
};

const SUPPLIER_ENDPOINTS = {
  AUTHENTICATION: {
    SEND_CODE: "supplier/send-code",
    REGISTER: "supplier/register",
    LOGIN: "supplier/login",
    FORGET_PASSWORD: "supplier/forget-password",
    VERIFY_PASSWORD: "supplier/verify-password",
    CHANGE_PASSWORD: "supplier/change-password",
    UPDATE_PROFILE: "supplier/update-profile/:id",
    GET_ALL_SUPPLIERS: "supplier/get-all",
    GET_SUPPLIER_DETAILS: "supplier/get-details/:id",
    UPDATE_SUBSCRIPTION: "supplier/update-subscription/:id",
    GET_CURRENT_SUBSCRIPTION: "supplier/current-subscription/:id",
    PURCHASE_SUBSCRIPTION: "supplier/purchase-subscription",
  },
  DASHBOARD: {
    GET_DASHBOARD_DATA: "supplier/dashboard/get/:id",
    GET_MONTHLY_REPORT: "supplier/dashboard/monthly-report/:id",
    GET_DAILY_REPORT: "supplier/dashboard/daily-report/:id",
  },
  PRODUCT: {
    CREATE: "supplier/product",
    UPDATE: "supplier/product/:id",
    UPDATE_STATUS: "supplier/product/:id/status",
    UPDATE_FEATURED_STATUS: "supplier/product/:id/featured-status",
    SINGLE_PRODUCT_BY_ID: "supplier/product/id/:id",
    SINGLE_PRODUCT_BY_SLUG: "supplier/product/slug/:slug",
    GET_ALL_PRODUCTS: "supplier/products",
    GET_ALL_PRODUCTS_REVIEWS: "supplier/products/reviews",
    SEARCH_PRODUCT_BY_SKU: "supplier/product/sku/:sku",
    RESTOCK_PRODUCT: "supplier/product/:id/restock",
    GET_INVENTORY_MOVEMENTS:
      "supplier/products/inventory/movements",
    EXPORT_INVENTORY_MOVEMENTS:
      "supplier/products/inventory/movements/export",
    UPDATE_VARIANT_STATUS: "supplier/product/:id/variant/:variantId/status",
    DELETE: "supplier/product/:id",
    STATUS_OFF_ON_DOWNGRADE: "supplier/product/status-off-on-downgrade/:id",
    EXPORT_PRODUCTS: "supplier/products/export",
  },
  CATEGORY: {
    GET_ALL: "admin/ecom-category/get-all",
  },
  SUB_CATEGORY: {
    GET_ALL: "admin/ecom-sub-category/get-all",
  },
  SUB_SUB_CATEGORY: {
    GET_ALL: "admin/ecom-sub-sub-category",
  },
  ECOMMERCE_TAGS: {
    GET_ALL: "admin/ecom-tag",
  },
  ATTRIBUTE: {
    GET_ALL_ATTRIBUTES_WITH_VALUES: "admin/attributes/with-values",
  },
  ORDER: {
    GET_ALL_ORDERS: "suppliers/:supplierId/orders",
    SINGLE_ORDER_BY_ID: "supplier/:supplierId/order/:id",
    UPDATE_ORDER_ITEM_STATUS: "supplier/order/:id/item/:itemId/status",
    UPDATE_ORDER_STATUS_IN_BULK: "supplier/order/:id/bulk-status",
  },
  DONATION: {
    GET_SINGLE_BY_ORDER_ID: "admin/donations/:orderId/order",
  },
  BASE_PACKAGE: {
    CREATE: "supplier/base/package",
    GET_ALL: "supplier/base/packages",
    GET_BY_ID: "supplier/base/package/id/:id",
    GET_BY_SLUG: "supplier/base/package/slug/:slug",
    UPDATE: "supplier/base/package/:id",
    DELETE: "supplier/base/package/:id",
    GENERATE_SPECIFICATION: "base/package/specification/",
    EXPORT_BASE_PACKAGES: "supplier/base/packages/export",
  },
  BRAND: {
    GET: "admin/brands",
  },
};

const CREATOR_ENDPOINTS = {
  AUTHENTICATION: {
    SEND_CODE: "creator/send-code",
    REGISTER: "creator/register",
    LOGIN: "creator/login",
    FORGET_PASSWORD: "creator/forget-password",
    VERIFY_PASSWORD: "creator/verify-password",
    CHANGE_PASSWORD: "creator/change-password",
    UPDATE_PROFILE: "creator/update-profile/:id",
  },
  CAMPAIGN: {
    GET_ALL: "creator/:creatorId/campaigns",
    MY_CAMPAIGNS: "creator/:creatorId/my-campaigns",
    DETAIL: "creator/:creatorId/campaign/:campaignId",
    PARTICIPATE: "creator/:creatorId/campaign/:campaignId/participate",
    SUBMIT_VIDEO: "creator/:creatorId/campaign/:campaignId/submission",
    MARK_POSTED: "creator/:creatorId/campaign/:campaignId/submission/posted",
  },
}

export {
  emailRegex,
  passwordRegex,
  otpRegex,
  cuiRegex,
  requestType,
  endPoints,
  snackConst,
  CURRENCY,
  STRIPE_KEY,
  MAX_IMAGE_SIZE,
  ALLOWED_IMAGE__FORMATS,
  ALLOWED_VIDEO_FORMATS,
  DEFAULT_VAT_PERCENTAGE,
  PRODUCT_USAGE_TYPE,
  PACKAGE_USAGE_TYPE,
  SUPPLIER_ENDPOINTS,
  skuRegex,
  partialSkuRegex,
  socialLinkRegex,
  INVENTORY_MOVEMENT_REASON,
  ORDER_STATUS_TRANSITIONS,
  CREATOR_ENDPOINTS,
};
